export default "__VITE_ASSET__DJ0BexAx__"